import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * Select component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    searchBar: {
      height: '3.2rem',
      marginLeft: theme.spacing(1),
      width: '250px',
      zIndex: 10,
      '& input': {
        // border: `1px solid ${variables.colorV2.input.search.border.default}`,
        borderRadius: '.8rem',
        height: '3.2rem',
      },
      '& > div > div': {
        backgroundColor: `${variables.colorV2.input.search.background.default} !important`,
        borderColor: '#ffffff !important',
        borderRadius: '5rem',
        borderWidth: '0.3rem',
      },

      '& > div > div > input': {
        paddingLeft: '1.7rem !important',
      },
    },
    filterSortMenu: {
      marginLeft: theme.spacing(1),
      '& button': {
        // backgroundColor: variables.colorV2.button.menu.background.default,
        // border: `1px solid ${variables.colorV2.button.menu.border.default}`,
        borderRadius: '2.8rem',
        height: '2.8rem',
        minWidth: '2.8rem',
        padding: '0.3rem 0.3rem',
        width: '2.8rem',

        '& svg path': {
          fill: variables.colorV2.button.outlined.primary.icon.fill.default,
        },

        '&:hover': {
          // backgroundColor: variables.colorV2.button.menu.background.hover,
          // border: `1px solid ${variables.colorV2.button.menu.border.hover}`,
        },
        '&:hover svg path': {
          fill: variables.colorV2.button.outlined.primary.icon.fill.hover,
          stroke: 'transparent',
        },
      },
    },
    uploadButton: {
      marginLeft: theme.spacing(1),
      minWidth: '3.2rem',
      padding: '0.6rem 0.6rem',
      width: '3.2rem',
      '&:hover': {
        backgroundColor: 'transparent', // variables.color.primary.backgroundLighterGray,
        // border: `1px solid ${variables.color.primary.mainPurple}`,
      },
      '&:hover svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.hover,
      },
    },
  }),
);
